import { ChangeDetectorRef, Inject, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { App } from '../../app';

import { NotesService } from '../../services/notes/notes.service';
import { Note } from '../../services/model/note';
import { Paragraph } from '../../services/model/paragraph';

@Component({
  selector: 'app-offerings',
  imports: [CommonModule],
  templateUrl: './offerings.html',
  styleUrl: './offerings.css'
})

export class Offerings implements OnInit{
  public notesFocus: Note;

  constructor(private cdRef: ChangeDetectorRef, private notesService: NotesService/*, private appComponent: App*/) {
    console.log('Loading Offerings')

    this.notesFocus = new Note('','','','','',[new Paragraph('', '', 0, [''], '', '')]);
    // this.appComponent.checkShowHeader = false;
    // this.appComponent.showHeader = true;

  }

  ngOnInit() {
    console.log('Offerings::Init')

    this.notesService.getNotes('offerings').subscribe(data => {
      this.notesFocus = data;
      this.cdRef.detectChanges();

    });
  }

  formatTextArray(textArray: [string], imagePosition: string, imageSrc: string){
    console.log('formatTextArray')
    let innerHTMLString = "";

    textArray.forEach(d => {
      innerHTMLString += d + "<br/>";
    })

    return innerHTMLString;
  }
}